var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"locked-page"},[_c('div',{staticClass:"locked-content"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"el-icon-lock"})]),_c('h1',[_vm._v("尾款逾期系统锁定")]),_c('p',[_vm._v("请联系管理员处理")])])])
}]

export { render, staticRenderFns }